import MyDeviceSelectorView from './MyDevicesSelectionDialog/MyDeviceSelectorView';

export default function MyDeviceApp() {
	return <MyDeviceSelectorView identity="test" />;
}
